import { get, getRawValue } from '../../utils/get';
import { CONTEXT_PROPS } from '../../types/ContextProps';
import { getKeys as _getKeys } from '../../adapters/utils';
var IDs = {
  SITE_NAME: 'site.name',
  PAGE_NAME: 'page.name',
  INDEX_SITE: 'site.index',
  INDEX_PAGE: 'page.index',
  GALLERY_TYPE: 'item.type',
  TITLE: 'item.title',
  DESCRIPTION: 'item.description',
  PAGE_URL: 'page.url',
  FULLSCREEN_URL: 'page.fullScreenUrl',
  IMAGE_URL: 'item.image.url',
  IMAGE_WIDTH: 'item.image.width',
  IMAGE_HEIGHT: 'item.image.height',
  VIDEO_URL: 'item.videoUrl',
  THUMBNAIL_URL: 'item.thumbnail.url',
  THUMBNAIL_WIDTH: 'item.thumbnail.width',
  THUMBNAIL_HEIGHT: 'item.thumbnail.height'
};
var userVisible = [IDs.TITLE, IDs.DESCRIPTION, IDs.IMAGE_URL, IDs.PAGE_NAME, IDs.GALLERY_TYPE, IDs.PAGE_URL, IDs.FULLSCREEN_URL, IDs.SITE_NAME];
export default {
  IDs: IDs,
  getData: function getData(item) {
    var _ref;

    return _ref = {}, _ref[IDs.SITE_NAME] = get(item, "context." + CONTEXT_PROPS.SITE_NAME), _ref[IDs.PAGE_NAME] = get(item, "context." + CONTEXT_PROPS.PAGE_NAME), _ref[IDs.INDEX_SITE] = getRawValue(item, "context." + CONTEXT_PROPS.INDEX_SITE), _ref[IDs.INDEX_PAGE] = getRawValue(item, "context." + CONTEXT_PROPS.INDEX_PAGE), _ref[IDs.GALLERY_TYPE] = ['image', 'video'].includes(get(item, 'item.type')) ? get(item, 'item.type') : 'website', _ref[IDs.TITLE] = get(item, 'item.title'), _ref[IDs.DESCRIPTION] = get(item, 'item.description'), _ref[IDs.PAGE_URL] = get(item, 'item.page_url'), _ref[IDs.FULLSCREEN_URL] = get(item, 'item.fullscreen_url'), _ref[IDs.IMAGE_URL] = get(item, 'item.image.url'), _ref[IDs.IMAGE_WIDTH] = get(item, 'item.image.width'), _ref[IDs.IMAGE_HEIGHT] = get(item, 'item.image.height'), _ref[IDs.VIDEO_URL] = get(item, 'item.video_url'), _ref[IDs.THUMBNAIL_URL] = get(item, 'item.thumbnail.url'), _ref[IDs.THUMBNAIL_WIDTH] = get(item, 'item.thumbnail.width'), _ref[IDs.THUMBNAIL_HEIGHT] = get(item, 'item.thumbnail.height'), _ref;
  },
  getLegacySeoBlob: function getLegacySeoBlob() {},
  getBiData: function getBiData() {},
  getKeys: function getKeys() {
    return _getKeys(IDs, userVisible);
  },
  getSlug: function getSlug() {
    return '';
  },
  updateItemDataWithSlug: function updateItemDataWithSlug(item) {
    return item;
  }
};